<script setup>
import { ref, computed } from 'vue'
import { useGlobalStore } from '@stores/global'
const emit = defineEmits(['update:modelValue'])
const props = defineProps(['modelValue', 'options'])

const globalStore = useGlobalStore()

const active = computed(() => props.options.findIndex((option) => option.name === props.modelValue))
const offset = computed(() => (globalStore.screenWidth < 1024 ? 2.5 : 2.75) * active.value + `rem`)
</script>

<template>
	<div class="relative flex select-none gap-1 border-2 border-crowns-off-white bg-crowns-off-black p-0.5 md:p-1">
		<div class="absolute z-10 h-8 w-9 bg-crowns-off-white transition-all duration-200 ease-in-out lg:h-9 lg:w-10" :style="`transform: translateX(${offset})`"></div>
		<button :class="['z-10 h-8 w-9 text-lg text-crowns-castle-shadow transition-colors duration-200 lg:h-9 lg:w-10 lg:text-xl', { 'text-crowns-dark-grey': active == i }]" v-for="(option, i) in props.options" @click="emit('update:modelValue', option.name)"><i :class="option.icon" :title="option?.title" :tabindex="i" role="button" :aria-pressed="active == i" /></button>
	</div>
</template>
